import React from "react";
import {
  Dialog,
  DialogContent,
  TextField,
  InputAdornment,
  Box,
  DialogActions,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import "../../Sass/Common.scss";
import { PrimaryDialogTitle } from "../../Components/Common/Dialog/DialogComponents";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import { ReactComponent as SearchIcon } from "../../Assets/Icons/SearchIcon.svg";
import DriverAutoComplete from "../../Components/Surgery/DriverAutoComplete";
import { makeStyles } from "@mui/styles";
const useStyle = makeStyles((theme) => ({
  dayAutocomplete: {
    background: theme.palette.white.main,
    border: "21x",
    borderColor: "black !important",
    border: "1px",
    height: "40px",
    borderStyle: "inset",
    // boxShadow: "0px 0px 10px rgb(90 104 114 / 10%)",
    borderRadius: "4px",
    lineHeight: "30px",
    minWidth: "100% !important",
    maxWidth: "253px !important",
    whiteSpace: "onwrap",
    height: "39px",
    marginRight: "13px",
    "&>div": {
      marginTop: "3px",
      padding: "10px",
      color: theme.palette.secondary.main,
      fontSize: "14px",
      height: "23px !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "& .MuiMenuItem": {
      color: theme.palette.secondary.main,
    },
  },
}));
const SearchAndFilterDialogSurgeryMobileView = (props) => {
  const {
    open,
    setOpen,
    maxValue,
    driverListFlag,
    changeDropDownValue,
    handleDriverChange,
    searchValue,
    setSearchValue,
    handleSearch,
    orderDayfilter,
    handleSelectOrderDay,
    orderDayMenuItems,
    showDataBasedOnRole,
    setOrderDayValue,
    getList,
  } = props;

  const classes = useStyle();
  /** handle close */
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth={"xs"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        className="rsUpdateDialog"
      >
        <PrimaryDialogTitle handleClose={handleClose} title="Filter" />
        <DialogContent>
          <Box display={"grid"}>
            {showDataBasedOnRole === "user" && (
              <Select
                value={orderDayfilter}
                className={classes.dayAutocomplete}
                onChange={handleSelectOrderDay}
                sx={{
                  height: 40,
                  marginBottom: "30px",
                }}
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
              >
                {orderDayMenuItems?.map((name) => (
                  <MenuItem
                    key={name.index}
                    value={name.lable}
                    onClick={() => {
                      console.log("name.value", name.value);
                      setOrderDayValue(name.value);
                      if (showDataBasedOnRole === "user") {
                        getList({
                          after_order_date_hour: name.value,
                        });
                      }
                    }}
                  >
                    {name.lable}
                  </MenuItem>
                ))}
              </Select>
            )}
            <DriverAutoComplete
              fullWidth
              multiple
              className="autoCompleteBoxMob"
              value={Object.values(changeDropDownValue || [])}
              maxValue={maxValue}
              driverListFlag={driverListFlag}
              handleChange={(value) => handleDriverChange(value)}
              renderInput={(params) => (
                <TextField {...params} label="Driver List" />
              )}
            />
            <TextField
              withPadding={true}
              medium
              secondary
              className="rsSearchMobFilter"
              placeholder="Search..."
              value={searchValue}
              onChange={(e) => {
                handleSearch(e?.target?.value);
                setSearchValue(e?.target?.value);
              }}
              InputProps={{
                endAdornment: (
                  <>
                    <InputAdornment position="end">
                      <PrimaryIcon width="20px" icon={SearchIcon} />
                    </InputAdornment>
                  </>
                ),
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={(e) => handleClose()}>
            Filter
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SearchAndFilterDialogSurgeryMobileView;
